import React from 'react';
import { Input, Button, CheckboxTable, Select } from 'components';
import { ChatService, StorageService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket } from 'utils';
import { CloseIcon, ImageIcon, Document2Icon } from 'assets/icons';
import moment from 'moment';
import { WhiteImage } from 'assets/img';

// Extensiones consideradas imagen -- mismo listado que usa el chat de
// cliente/abogado (screens/client/chat/chat.tsx) para decidir si el archivo
// adjunto se etiqueta como "Imagen" o se muestra con su extensión.
const IMAGE_EXTS = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'bmp',
  'tiff',
  'tif',
  'avif',
  'heic',
  'heif',
];

interface Props {
  onClose?: any;
  item?: any;
}

class ViewChat extends React.Component<Props> {
  messagesEnd: any = null;

  state = {
    chat: null,
    messages: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async (withoutScroll = false) => {
    const res: any = await ChatService.admin.view({
      chat_id: this.props.item?.id,
    });
    this.setState(
      {
        chat: res.chat,
        messages: res.messages || [],
      },
      () => {
        if (!withoutScroll) {
          this.scrollToBottom();
        }
      },
    );
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight,
    });
  };

  render() {
    const chat: any = this.state.chat;

    return (
      <div id='admin-view-chat'>
        <div className='header-modal'>
          {chat != null && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
              <div className='container-images-modal'>
                <img
                  src={
                    chat?.sender?.photo ? Constants.BASE_STORAGE + chat?.sender?.photo : WhiteImage
                  }
                />
                {chat?.lawyer != null && (
                  <img
                    src={
                      chat?.receiver?.photo
                        ? Constants.BASE_STORAGE + chat?.receiver?.photo
                        : WhiteImage
                    }
                    className='img-lawyer'
                  />
                )}
              </div>
              <p>
                Chat {chat?.sender?.full_name} y {chat?.receiver?.full_name}
              </p>
            </div>
          )}
          <button className='btn-close' onClick={() => this.props.onClose()}>
            <img src={CloseIcon} />
          </button>
        </div>
        <div
          className='container-scroll-modal-right'
          ref={(el) => {
            this.messagesEnd = el;
          }}
        >
          <div className='container-messages'>
            {this.state.messages.map((item: any) => {
              const is_right = item.user?.id === chat?.receiver?.id;

              if (item.file) {
                const ext = item.file.split('.').pop()?.toLowerCase();
                const isImage = IMAGE_EXTS.includes(ext);
                const fileLabel = isImage ? 'Imagen' : ext?.toUpperCase();
                return (
                  <a
                    href='#'
                    onClick={(e: any) => {
                      e.preventDefault();
                      StorageService.openFile(item.file);
                    }}
                    className={`link-file ${is_right ? 'self' : ''}`}
                    style={{ alignSelf: is_right ? 'flex-end' : 'flex-start' }}
                  >
                    <p className='name' style={{ textAlign: is_right ? 'right' : 'left' }}>
                      {item.user?.full_name}
                    </p>
                    <img src={isImage ? ImageIcon : Document2Icon} />
                    <p>
                      Archivo Adjunto <span>({fileLabel})</span>
                    </p>
                    {moment(item.created_at).isValid() && (
                      <p className='date'>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</p>
                    )}
                  </a>
                );
              }

              return (
                <div
                  className={`message ${is_right ? 'right' : ''}`}
                  style={{ alignSelf: is_right ? 'flex-end' : 'flex-start' }}
                >
                  <p className='name' style={{ textAlign: is_right ? 'right' : 'left' }}>
                    {item.user?.full_name}
                  </p>
                  <p className={is_right ? 'text-right' : 'text-left'}>{item.message}</p>
                  {moment(item.created_at).isValid() && (
                    <p className='date' style={{ textAlign: is_right ? 'left' : 'right' }}>
                      {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default ViewChat;
